var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.397 2.07a4.33 4.33 0 0 1 4.33 4.331 4.33 4.33 0 0 1-1.265 3.058l.001.001-7.848 8.01-.004.004a2.467 2.467 0 0 1-3.489-3.488l7.845-8.005a.6.6 0 0 1 .858.84l-7.849 8.01-.005.004a1.267 1.267 0 0 0 .896 2.161c.335 0 .658-.134.895-.371l7.845-8.005.004-.004a3.132 3.132 0 0 0-4.429-4.428l-7.811 7.971-.008.009-.001-.001a4.998 4.998 0 1 0 7.067 7.067l7.816-7.976a.6.6 0 0 1 .857.84l-7.816 7.977-.001.001a6.196 6.196 0 1 1-8.772-8.757l7.817-7.976.003-.004a4.33 4.33 0 0 1 3.064-1.269"
  })));
};
export default SvgPaperclip;